export default {
  'app.settings.menuMap.basic': '基本设置',
  'app.settings.menuMap.security': '安全设置',
  'app.settings.menuMap.binding': '账号绑定',
  'app.settings.menuMap.notification': '新消息通知',
  'app.settings.basic.avatar': '头像',
  'app.settings.basic.change-avatar': '更换头像',
  'app.settings.basic.email': '邮箱',
  'app.settings.basic.email-message': '请输入您的邮箱!',
  'app.settings.basic.nickname': '昵称',
  'app.settings.basic.nickname-message': '请输入您的昵称!',
  'app.settings.basic.profile': '个人简介',
  'app.settings.basic.profile-message': '请输入个人简介!',
  'app.settings.basic.profile-placeholder': '个人简介',
  'app.settings.basic.country': '国家/地区',
  'app.settings.basic.country-message': '请输入您的国家或地区!',
  'app.settings.basic.geographic': '所在省市',
  'app.settings.basic.geographic-message': '请输入您的所在省市!',
  'app.settings.basic.address': '街道地址',
  'app.settings.basic.address-message': '请输入您的街道地址!',
  'app.settings.basic.phone': '联系电话',
  'app.settings.basic.phone-message': '请输入您的联系电话!',
  'app.settings.basic.update': '更新基本信息',
  'app.settings.security.strong': '强',
  'app.settings.security.medium': '中',
  'app.settings.security.weak': '弱',
  'app.settings.security.password': '账户密码',
  'app.settings.security.password-description': '当前密码强度',
  'app.settings.security.phone': '密保手机',
  'app.settings.security.phone-description': '已绑定手机',
  'app.settings.security.question': '密保问题',
  'app.settings.security.question-description':
    '未设置密保问题，密保问题可有效保护账户安全',
  'app.settings.security.email': '备用邮箱',
  'app.settings.security.email-description': '已绑定邮箱',
  'app.settings.security.email-unbound': '未绑定邮箱',
  'app.settings.security.email-update-title': '修改邮箱',
  'app.settings.security.email-required': '请输入邮箱',
  'app.settings.security.email-invalid': '邮箱格式不正确',
  'app.settings.security.email-input-placeholder': '请输入邮箱',
  'app.settings.security.email-update-success': '邮箱更新成功',
  'app.settings.security.email-update-failed': '邮箱更新失败',
  'app.settings.security.mfa': 'MFA 设备',
  'app.settings.security.mfa-description':
    '未绑定 MFA 设备，绑定后，可以进行二次确认',
  'app.settings.security.mfa-enabled-description':
    '已绑定 OTP 设备，可使用动态验证码进行二次验证',
  'app.settings.security.modify': '修改',
  'app.settings.security.change-password': '修改密码',
  'app.settings.security.otp-title': 'OTP 管理',
  'app.settings.security.otp-bind': '绑定 OTP',
  'app.settings.security.otp-manage': 'OTP 管理',
  'app.settings.security.otp-setup-description':
    '使用 Google Authenticator 或 Microsoft Authenticator 扫描二维码，然后输入 6 位验证码完成绑定。',
  'app.settings.security.otp-load-failed': '获取 OTP 二维码失败',
  'app.settings.security.otp-qr-unavailable':
    '二维码暂时不可用，请使用手动密钥绑定',
  'app.settings.security.otp-manual-key': '手动输入密钥',
  'app.settings.security.otp-code': '6 位验证码',
  'app.settings.security.otp-code-required': '请输入 6 位验证码',
  'app.settings.security.otp-code-invalid': '验证码必须为 6 位数字',
  'app.settings.security.otp-code-placeholder': '请输入验证码',
  'app.settings.security.otp-refresh-qr': '刷新二维码',
  'app.settings.security.otp-enable': '启用 OTP',
  'app.settings.security.otp-enable-success': 'OTP 已启用',
  'app.settings.security.otp-enable-failed': '启用 OTP 失败',
  'app.settings.security.otp-enabled-title': 'OTP 已启用',
  'app.settings.security.otp-enabled-description':
    '当前账户已绑定 OTP 设备。如需解绑，请输入当前密码。',
  'app.settings.security.otp-disable': '禁用 OTP',
  'app.settings.security.otp-disable-success': 'OTP 已禁用',
  'app.settings.security.otp-disable-failed': '禁用 OTP 失败',
  'app.settings.security.otp-disable-password': '当前密码',
  'app.settings.security.otp-disable-password-required':
    '请输入当前密码以禁用 OTP',
  'app.settings.security.otp-disable-password-placeholder': '请输入当前密码',
  'app.settings.security.otp-binding': 'OTP 绑定',
  'app.settings.security.otp-binding-title': '绑定 OTP 验证器',
  'app.settings.security.otp-binding-subtitle':
    '为了保护您的账户安全，请绑定 OTP 验证器',
  'app.settings.security.otp-binding-alert':
    '请使用 Google Authenticator 或 Microsoft Authenticator 扫描二维码',
  'app.settings.security.old-password': '当前密码',
  'app.settings.security.old-password-required': '请输入当前密码',
  'app.settings.security.old-password-placeholder': '请输入当前密码',
  'app.settings.security.new-password': '新密码',
  'app.settings.security.new-password-required': '请输入新密码',
  'app.settings.security.new-password-placeholder': '请输入新密码',
  'app.settings.security.confirm-password': '确认新密码',
  'app.settings.security.confirm-password-required': '请再次输入新密码',
  'app.settings.security.confirm-password-placeholder': '请再次输入新密码',
  'app.settings.security.confirm-password-mismatch': '两次输入的新密码不一致',
  'app.settings.security.password-rule':
    '8-20 位，包含大小写字母、数字和特殊字符 @$!%*?&',
  'app.settings.security.password-different': '新密码不能与当前密码相同',
  'app.settings.security.change-password-success': '密码修改成功',
  'app.settings.security.change-password-failed': '密码修改失败',
  'app.settings.security.submit': '确认修改',
  'app.settings.security.cancel': '取消',
  'app.settings.security.set': '设置',
  'app.settings.security.bind': '绑定',
  'app.settings.binding.taobao': '绑定淘宝',
  'app.settings.binding.taobao-description': '当前未绑定淘宝账号',
  'app.settings.binding.alipay': '绑定支付宝',
  'app.settings.binding.alipay-description': '当前未绑定支付宝账号',
  'app.settings.binding.dingding': '绑定钉钉',
  'app.settings.binding.dingding-description': '当前未绑定钉钉账号',
  'app.settings.binding.bind': '绑定',
  'app.settings.notification.password': '账户密码',
  'app.settings.notification.password-description':
    '其他用户的消息将以站内信的形式通知',
  'app.settings.notification.messages': '系统消息',
  'app.settings.notification.messages-description':
    '系统消息将以站内信的形式通知',
  'app.settings.notification.todo': '待办任务',
  'app.settings.notification.todo-description': '待办任务将以站内信的形式通知',
  'app.settings.open': '开',
  'app.settings.close': '关',
};
